<template>
  <div class="goods-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenTopBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'GoodsDetailTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenTopBtn: false,
        tableRules: {
          productDesc: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          storageName: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          productQuantity: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          cgBusinessContractUnitPrice: [
            { required: true, message: '必填字段', trigger: ['change', 'blur'] },
          ],
          ssBusinessContractUnitPrice: [
            { required: true, message: '必填字段', trigger: ['change', 'blur'] },
          ],
        },
        ids: [], // 被删除的数据id集合
        orderDetailDelIds: [], // 删除id集合
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          { type: 'seq', title: '行项目号', width: 100 },
          {
            field: 'productDesc',
            title: '商品描述',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <div>
                    <span>{row['productDesc']}</span>
                    {this.isShowVariablePriceIcon && row['isFixedPrice'] == '0' && (
                      <i
                        class="el-icon-chat-square icon-btn"
                        onClick={(val) => this.clickProductDetailDialog(val, row, 'productDesc')}
                      ></i>
                    )}
                  </div>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="usableProduct"
                    isMultiple={true}
                    extraData={{
                      detailProductStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                      selectCompanyCode: this.userInfo.companyCode,
                    }}
                    currentValue={row['productDesc']}
                    checkRowKeys={[row['productNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'productDesc')}
                  ></SearchTable>,
                ];
              },
            },
          },
          {
            field: 'norms',
            title: '规格',
            width: 150,
          },
          {
            field: 'stuff',
            title: '材料',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
          {
            field: 'productQuantity',
            title: '合同数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入合同数量',
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <div>
                    <span>{row['productQuantity']}</span>
                  </div>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <InputNumber
                    value={row['productQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'productQuantity')}
                  ></InputNumber>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'unitName',
            title: '单位',
            width: 150,
          },
          {
            field: 'storageName',
            title: '仓库',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入仓库',
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['storageName']}</span>];
              },
              // selectCompanyCode: this.companyCode || this.userInfo.companyCode,
              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="warehouse"
                    isMultiple={true}
                    extraData={{
                      currentStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                    }}
                    currentValue={row['storageName']}
                    checkRowKeys={[row['storageNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'storageName')}
                  ></SearchTable>,
                ];
              },
            },
          },
          {
            field: '',
            title: '采购端',
            align: 'center',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            children: [
              {
                field: 'cgBusinessContractUnitPrice',
                title: '合同单价',
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [
                      <div>
                        <span>{row['cgBusinessContractUnitPrice']}</span>
                      </div>,
                    ];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumber
                        value={row['cgBusinessContractUnitPrice']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        onInput={(val) => this.updateCol(row, val, 'cgBusinessContractUnitPrice')}
                      ></InputNumber>,
                    ];
                  },
                },
                width: 150,
              },
              {
                field: 'cgBusinessContractTotalAmount',
                title: '价税合计金额',
                width: 150,
              },
              {
                field: 'cgBusinessContractTaxAmount',
                title: '税额',
                width: 150,
              },
              // {
              //   field: 'cgBusinessContractPureAmount',
              //   title: '净值',
              //   editRender: {
              //     name: 'ElInput',
              //     props: {
              //       clearable: true,
              //     },
              //   },
              //   slots: {
              //     default: ({ row }) => {
              //       return [<span>{row['cgBusinessContractPureAmount']}</span>];
              //     },
              //     edit: ({ row }) => {
              //       return [<span>{row['cgBusinessContractPureAmount']}</span>];
              //     },
              //   },
              //   width: 150,
              // },
              {
                field: 'cgTaxRate',
                title: '进项税码',
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [
                      <div>
                        <span>{row['cgTaxRate']}</span>
                      </div>,
                    ];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumber
                        value={row['cgTaxRate']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        onInput={(val) => this.updateCol(row, val, 'cgTaxRate')}
                      ></InputNumber>,
                    ];
                  },
                },
                width: 150,
              },
            ],
          },
          {
            field: '',
            title: '销售端',
            align: 'center',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            children: [
              {
                field: 'ssBusinessContractUnitPrice',
                title: '合同单价',
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [
                      <div>
                        <span>{row['ssBusinessContractUnitPrice']}</span>
                      </div>,
                    ];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumber
                        value={row['ssBusinessContractUnitPrice']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        onInput={(val) => this.updateCol(row, val, 'ssBusinessContractUnitPrice')}
                      ></InputNumber>,
                    ];
                  },
                },
                width: 150,
              },
              {
                field: 'ssBusinessContractTotalAmount',
                title: '价税合计金额',

                width: 150,
              },
              {
                field: 'ssBusinessContractTaxAmount',
                title: '税额',

                width: 150,
              },
              // {
              //   field: 'ssBusinessContractPureAmount',
              //   title: '净值',
              //   editRender: {
              //     name: 'ElInput',
              //     props: {
              //       clearable: true,
              //     },
              //   },
              //   slots: {
              //     default: ({ row }) => {
              //       return [<span>{row['ssBusinessContractPureAmount']}</span>];
              //     },
              //     edit: ({ row }) => {
              //       return [<span>{row['ssBusinessContractPureAmount']}</span>];
              //     },
              //   },
              //   width: 150,
              // },
              {
                field: 'ssTaxRate',
                title: '销项税码',
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [
                      <div>
                        <span>{row['ssTaxRate']}</span>
                      </div>,
                    ];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumber
                        value={row['ssTaxRate']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        onInput={(val) => this.updateCol(row, val, 'ssTaxRate')}
                      ></InputNumber>,
                    ];
                  },
                },
                width: 150,
              },
            ],
          },
        ];
      },
    },
    methods: {
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      // 关闭的
      closeEditTableHandler() {
        console.log('关闭');
        this.$emit('closeTableHandler', this.getTableData());
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field, '====>');
        row[field] = fieldValue;
        this.$forceUpdate();
        if (
          field == 'productQuantity' ||
          field == 'cgBusinessContractUnitPrice' ||
          field == 'cgTaxRate'
        ) {
          // 采购
          // 价税合计
          row['cgBusinessContractTotalAmount'] = (
            +row['productQuantity'] * +row['cgBusinessContractUnitPrice']
          ).toFixed(6);
          // 税额
          row['cgBusinessContractTaxAmount'] = row['cgTaxRate']
            ? (
                (row['cgBusinessContractUnitPrice'] / (1 + +row['cgTaxRate'])) *
                row['productQuantity'] *
                row['cgTaxRate']
              ).toFixed(6)
            : '';
        }
        if (
          field == 'productQuantity' ||
          field == 'ssBusinessContractUnitPrice' ||
          field == 'ssTaxRate'
        ) {
          // 销售
          // 价税合计
          row['ssBusinessContractTotalAmount'] = (
            +row['productQuantity'] * +row['ssBusinessContractUnitPrice']
          ).toFixed(6);
          // 税额
          row['ssBusinessContractTaxAmount'] = row['ssTaxRate']
            ? (
                (row['ssBusinessContractUnitPrice'] / (1 + +row['ssTaxRate'])) *
                row['productQuantity'] *
                row['ssTaxRate']
              ).toFixed(6)
            : '';
        }
      },
      chooseTable(val, row, prop) {
        console.log(val, row, prop);
        const rowData = val && Array.isArray(val) ? val[0] : {};
        if (prop == 'productDesc') {
          row['productNo'] = rowData?.productDetailCode
            ? rowData?.productDetailCode
            : rowData?.parentProductNo;
          row['productDesc'] = rowData?.productChName;
          row['norms'] = rowData?.detailProductModel;
          row['stuff'] = rowData?.detailProductMaterial;
          row['unitName'] = rowData?.basicUnitName;
          row['unit'] = rowData?.basicUnit;
          row['cgTaxCode'] = rowData?.valueAddedTaxCode;
          row['cgTaxName'] = rowData?.valueAddedTaxName;
          row['cgTaxRate'] = rowData?.valueAddedTaxRate;
          row['ssTaxCode'] = rowData?.salesTaxCode;
          row['ssTaxName'] = rowData?.salesTaxName;
          row['ssTaxRate'] = rowData?.salesTaxRate;
        } else if (prop == 'storageName') {
          row['storageCode'] = rowData?.storageCode;
          row['storageNo'] = rowData?.storageCode;
          row['storageName'] = rowData?.storageName;
        }
        // const rowData = val && Array.isArray(val) ? val[0] : {};
        // console.log(rowData);
      },
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        const cgContractIdList = this.selectionList
          .map((item) => item.cgContractId)
          .filter((item) => Boolean(item));
        const ssContractIdList = this.selectionList
          .map((item) => item.ssContractId)
          .filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.orderDetailDelIds = [...cgContractIdList, ...ssContractIdList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 获取表格数据
      getValidateTableData(isValidate = true) {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData.map((item, index) => {
            return {
              ...item,
              contractDetailNo: index + 1,
            };
          });
          if (isValidate) {
            $table.validate((valid) => {
              if (valid && tableData.length) {
                resolve({ tableData, deleteStorageLineIds: this.orderDetailDelIds });
              } else {
                this.$message.error('请填写表格数据');
                reject({ tableData: [], deleteStorageLineIds: [] });
              }
            });
          } else {
            resolve({ tableData, deleteStorageLineIds: this.orderDetailDelIds });
          }
        });
      },
      fullTableData(val) {
        if (val && Array.isArray(val) && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    watch: {
      fetchTableData: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
      },
      contractStatus: {
        handler(currentContractStatus) {
          if (currentContractStatus) {
            console.log(currentContractStatus, '监听当前状态');
            if (currentContractStatus == 'ZT02') {
              // 审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT03') {
              // 已生效
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT07') {
              // 已关闭状态表格不能编辑按钮没有
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 修订审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 审批修订中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT025') {
              // 删除审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT024') {
              // 生效审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT022') {
              // 撤回审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT023') {
              // 关闭审批中
              // 撤回审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT061') {
              // 修订中,部分控件要禁止
              console.log('等待处理');
            } else if (currentContractStatus == 'ZT051') {
              // 修改已驳回,部分控件要禁止
              console.log('等待处理');
            } else {
              console.log('等待处理');
            }
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
